<div class="driver-success-model">
    <img src="../../../../assets/images/driver-success.png" alt="Driver Success" />
    <h4> {{heading ? heading:'Success!'}}</h4>
    <p [innerHTML]="bodyText"></p>
    <div class="btn-outer">
        <p-button *ngIf="!bookingId" label="{{buttonText}}"  (onClick)="isrefresh ? closeAndRefresh() : cancelDialog()"/>
        <p-button *ngIf="bookingId" label="{{buttonText}}"  (onClick)="okButtonRedirectiononExtendBooking()"/>
    </div>
</div>